<bl19-toolbar></bl19-toolbar>
<main class="main-content">
    <router-outlet></router-outlet>
    <bl19-cookie-consent></bl19-cookie-consent>
    <bl19-footer></bl19-footer>
</main>